import React from "react";
import { Label, Button } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import { Input } from "../../../core";

function HostNameForm(props) {
  return (
    <div className="row mt-3">
      <div className="col-md-2 informationBlock">
        <Label for="exampleSelect" className="mt-2">
          Host Name
        </Label>
      </div>
      <div className="col-md-10 informationTag">
        <Field
          component={Input}
          name="hostname"
          maxlength="30"
          placeholder="Enter Host Name"
          inputClass="mr-0 mb-0 "
        />
        <Button
          className="btn-info ml-2"
          color="info"
          onClick={props.handleSubmit(props.handleHostNameChange)}
          disabled={props.submitting || props.pristine}
        >
          {props.submitting ? "Saving" : "Save"}
        </Button>
      </div>
    </div>
  );
}

export default reduxForm({
  form: "hostNameForm"
})(HostNameForm);
